import { useState } from "react";
import { FolderSearch, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { pickFolder } from "@/lib/agent";

export function FolderPickerButton({ onPicked, testid = "pick-folder-btn" }) {
  const [busy, setBusy] = useState(false);
  const pick = async () => {
    setBusy(true);
    try {
      const d = await pickFolder();
      if (d?.ok && d.path) onPicked(d.path);
      else if (!d?.cancelled) toast.error(d?.error || "No se pudo seleccionar la carpeta");
    } catch (e) {
      toast.error(
        e?.status === 404 || e?.status === 405
          ? "Tu agente está desactualizado. Ve a Configuración → Instalar / actualizar agente y ejecuta el comando una vez."
          : "No se pudo contactar con el Agent local."
      );
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button
      type="button"
      data-testid={testid}
      onClick={pick}
      disabled={busy}
      className="shrink-0 rounded-sm bg-white text-black hover:bg-neutral-200"
    >
      {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <FolderSearch className="mr-2 h-4 w-4" />}
      {busy ? "Elige en el Mac…" : "Elegir carpeta…"}
    </Button>
  );
}
